import React, { useRef, useState } from "react";
import "../css/cheque.css";
import "../css/common.scss";
import loading from "../img/loader.gif";
import Resizer from 'react-image-file-resizer';
import front from "../img/cheque.png";
import ChequeForm from "./ChequeForm";
import config from "../config/config";
import OptionsSwitch from "./Optionswitch";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { decryptData } from "../utils/encrypDecrypt";


const Cheque = (props) => {
    // console.log(uuid);
    const fileInputRef = useRef(null);
    const [files, setFiles] = useState([]);
    const [response, setResponse] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [image, setImage] = useState([]);
    const [loader, setLoader] = useState(0);
    const [imagenum, setImagenum] = useState(0);
    const [show,setShow] = useState(0);
    const [mode, setMode] = useState("Scan"); // Track mode: "Scan" or "Manual"
    let childSubmitFunction;

    const proceed = ()=>{
        setShow(1);
    }

    const handleSubmitinfo = () => {
        childSubmitFunction();
    };

    const toggleMenu = () => {
        fileInputRef.current.click();
    };

    const fileHandle = (event) => {
        const newFiles = Array.from(event.target.files);
        const existingFileNames = files.map((file) => file.name);
        const uniqueNewFiles = newFiles.filter((file) => !existingFileNames.includes(file.name));

        if (uniqueNewFiles.length > 0) {
            const updatedFiles = [...files, ...uniqueNewFiles];
            setFiles(updatedFiles);
            setSelectedFiles(updatedFiles.map((file) => file.name));
            // console.log("Selected Files:", updatedFiles);

            resizeAndCompressImages(updatedFiles);
        } else {
            console.log("No new files to process.");
        }
    };


    const resizeAndCompressImages = (files) => {
        const resizedFilesPromises = files.map(file =>
            resizeImage(file)
        );

        Promise.all(resizedFilesPromises)
            .then(resizedFiles => {
                makeApiCall(resizedFiles);
            })
            .catch(error => {
                console.error("Error resizing images:", error);
            });
    };

    const resizeImage = (file) => {
        return new Promise((resolve, reject) => {
            Resizer.imageFileResizer(
                file, // input file
                1024, // max width
                1024, // max height
                'JPEG', // output format
                50, // quality (0-100)
                0, // rotation (0, 90, 180, 270)
                (uri) => {
                    // uri is the resized image
                    const resizedFile = uri instanceof Blob ? uri : dataURLtoFile(uri, file.name);
                    resolve(resizedFile);
                },
                'base64' // output type ('base64', 'blob', or 'file')
            );
        });
    };

    const dataURLtoFile = (dataUrl, filename) => {
        const arr = dataUrl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        // Ensure proper variable declarations, no reassignment of 'const'
        for (let i = 0; i < n; i++) {
            u8arr[i] = bstr.charCodeAt(i);
        }

        // Create the file object
        return new File([u8arr], filename, { type: mime });
    };



    const makeApiCall = async (newFiles) => {
        setLoader(1);
        const formData = new FormData();

        newFiles.forEach((file) => {
            formData.append('images', file);
        });

        try {
            const response = await fetch(`${config.API_BASE_URL}/api/cheque`, {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                const result = await response.json();
                // console.log("API Response:", result);
                const decryptedData = JSON.parse(decryptData(result.data));

                if (decryptedData.images) {
                    setImage(decryptedData.images);
                }

                const data = decryptedData.data.data.components.prompt_builder;
                const normalizedResponse = Object.fromEntries(
                    Object.entries(data).map(([key, value]) => [key.replace(/_/g, '-'), value])
                );
                setResponse(normalizedResponse);
            } else {
                console.error("Error in API response:", response.statusText);
            }
        } catch (error) {
            console.error("API Error:", error);
        } finally {
            setLoader(0);
        }
    };

    const handleimagepreview = (index) => {
        setImagenum(index);
    };
    const handleModeChange = (selectedMode) => {
        setMode(selectedMode);
        // console.log(mode);
    };

    
    return (
        <>
            <Navbar/>
             <div className="fullbody container container-50 main-content">
             <div className='row'>
             <div className='col-12'>
                <div className="innerbody card">
                    
                    <OptionsSwitch selectedOption={mode} onModeChange={handleModeChange} />
                     <div className="card-body">
                        <span className="copyright" style={{fontWeight:"600"}}>
                            Selected Mode:
                        {mode == " Scan" ?"Auto":" Manual"}
                        </span>
                        <div className="demo-text mt-2">
                        {mode == "Scan" ?
                        <p className="copyright" >Scan Check and we will auto pull your information. <a onClick={() => handleModeChange("Manual")}
                        style={{ cursor: "pointer", color: "#d7172f" }}>Switch to Manual</a></p>:<p className="copyright">Please provide your payment information.<a onClick={() => handleModeChange("Scan")}
                        style={{ cursor: "pointer", color: "#d7172f" }}> Switch to Auto</a></p>}
                        </div>
                <div>
                {mode == "Scan" ?(<div>  
                    {image.length != 0 && (
                        <>
                            {show == 1 ?
                                <div className="resultbox2" style={{ justifyContent: "center" }}>
                                    <div >
                                        <ChequeForm
                                            setSubmitFunction={(submitFunction) => (childSubmitFunction = submitFunction)}
                                            account_number={response["account-number"]}
                                            bank_name={response["bank-name"]}
                                            date_of_issue={response["date-of-issue"]}
                                            payee={response["payee"]}
                                            routing_number={response["routing-number"]}
                                            zipcode=''
                                            uuid= {props.uuid}
                                        />
                                    </div>
                                </div>
                                : ""}
                        </>
                    )}
                 
                        {image.length === 0 ? (
                                <div className="resultbox1 mt-4 mb-2" style={{ "--background-image": `url(${front})` }}>
                                    <div className="overlay-text" onClick={toggleMenu}>
                                        {loader ?
                                            <div style={{ textAlign: "center", position: "absolute", display: "flex",width: "100%",justifyContent:"center" }}>
                                            <img className="loader-img" style={{ width: "30%" }} src={loading} alt="Loading..." />
                                            </div>: ""}
                                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 48 48">
                                                <path fill="#FFFFFF" d="M 23.978516 6 A 1.50015 1.50015 0 0 0 22.939453 6.4394531 L 16.939453 12.439453 A 1.50015 1.50015 0 1 0 19.060547 14.560547 L 22.5 11.121094 L 22.5 32.5 A 1.50015 1.50015 0 1 0 25.5 32.5 L 25.5 11.121094 L 28.939453 14.560547 A 1.50015 1.50015 0 1 0 31.060547 12.439453 L 25.060547 6.4394531 A 1.50015 1.50015 0 0 0 23.978516 6 z M 11.5 17 C 8.4802259 17 6 19.480226 6 22.5 L 6 36.5 C 6 39.519774 8.4802259 42 11.5 42 L 36.5 42 C 39.519774 42 42 39.519774 42 36.5 L 42 22.5 C 42 19.480226 39.519774 17 36.5 17 L 34.5 17 A 1.50015 1.50015 0 1 0 34.5 20 L 36.5 20 C 37.898226 20 39 21.101774 39 22.5 L 39 36.5 C 39 37.898226 37.898226 39 36.5 39 L 11.5 39 C 10.101774 39 9 37.898226 9 36.5 L 9 22.5 C 9 21.101774 10.101774 20 11.5 20 L 13.5 20 A 1.50015 1.50015 0 1 0 13.5 17 L 11.5 17 z"></path>
                                            </svg>
                                        <div>
                                            Upload or Scan Check
                                        </div>
                                    </div>
                                </div>
                            ):(
                                show !=1?
                                    <div className=" mt-4 mb-2" style={{ justifyContent: "center" }}>
                                        <div className="resultbox">
                                            <img style={{ width: "100%", height: "213px", objectFit: "contain" }} src={`data:image/jpeg;base64,${image[0]}`} alt="img" />
                                        </div>
                                    </div>:""
                            )}
                    {show == 1?    
                        (
                            <div
                                style={{
                                    display: "flex",
                                    overflowX: "auto",
                                    gap: "10px",
                                    marginTop: "40px",
                                    padding: "5px",
                                    background: "#FFFFFF",
                                    border: "1px solid #dddddd",
                                    height: "200px"
                                }}
                            >
                                {image.map((preview, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            position: "relative",
                                            display: "flex",
                                            flexShrink: 0,
                                            // width: "48%",
                                            background: "#FFFFFF",
                                            cursor: "pointer",
                                            width: "100%",
                                        }}
                                    >
                                        <img
                                            style={{
                                                width: "100%",
                                                objectFit: "contain",
                                                // border: "2px solid #d0caca",
                                            }}
                                            src={`data:image/jpeg;base64,${preview}`}
                                            alt="img"
                                            onClick={() => handleimagepreview(index)}
                                        />
                                    </div>
                                ))}
                            </div>
                        ):""}
                 </div>): (
                    <div className="mt-0 mb-2">
                        <ChequeForm  
                        setSubmitFunction={(submitFunction) => (childSubmitFunction = submitFunction)}
                        account_number=''
                        bank_name=''
                        date_of_issue=''
                        payee=''
                        routing_number=''
                        zipcode=''
                        uuid= {props.uuid}
                        />
                    </div> )}
                </div>
            </div>
            </div>

                <input type="file" ref={fileInputRef} style={{ display: 'none' }} multiple onChange={fileHandle} />
                    
            <div className="copyright pb-2 mt-2" style={{fontWeight:"500",fontSize:"15px",width:"100%",}}>
            {mode == "Manual" ?  
                <p>Please verify and enter correct information before final submission.</p>:""}
            
            {mode == "Scan" && show==1? <p>Based on your Check, we have pulled the following information shown above. Please verify and enter correct information before final submission</p>:""
            }
            {(show !== 0 || mode !="Scan" ) ?
                    <div className="submitbtn">
                        <button onClick={handleSubmitinfo} className="btn btn-xl w-100 btn-primary saveinfo">Submit</button>
                    </div>
                    : ""}
            </div>

                {image.length !=0  && show != 1  ?
                    <div className="submitbtn">
                        <button onClick={proceed} className="btn btn-xl w-100 btn-primary">Next</button>
                    </div>
                : ""}

        </div>
        </div>
        </div>
        <Footer/>
        </>
    );
};

export default Cheque;
